// extracted by mini-css-extract-plugin
export var border = "_18-7";
export var brand = "_18-s";
export var button = "_18-k";
export var center = "_18-9";
export var centered = "_18-5";
export var closeButton = "_18-b";
export var disabledWrapper = "_18-l";
export var error = "_18-o";
export var extraLarge = "_18-4";
export var extraSmall = "_18-1";
export var fill = "_18-h";
export var footer = "_18-g";
export var footerAction = "_18-i";
export var footerButtons = "_18-j";
export var header = "_18-6";
export var headerWithClose = "_18-c";
export var icon = "_18-n";
export var info = "_18-r";
export var inline = "_18-8";
export var large = "_18-3";
export var main = "_18-d";
export var modal = "_18-0";
export var neutral = "_18-t";
export var noPadding = "_18-f";
export var none = "_18-u";
export var scrollable = "_18-e";
export var small = "_18-2";
export var success = "_18-q";
export var tight = "_18-m";
export var titleIcon = "_18-a";
export var warn = "_18-p";